export const languageIterator = (
  filteredLanguages,
  currentFocusedLanguageIndex,
  activeLanguageIndex,
) => {
  const languagesCount = filteredLanguages.length;

  const focusNextLanguage = () => {
    if (currentFocusedLanguageIndex === null) {
      return activeLanguageIndex !== -1 ? activeLanguageIndex : 0;
    }
    if (currentFocusedLanguageIndex === languagesCount - 1) {
      return 0;
    }
    return ++currentFocusedLanguageIndex;
  };

  const focusPreviousLanguage = () => {
    if (currentFocusedLanguageIndex === null) {
      return activeLanguageIndex !== -1 ? activeLanguageIndex : 0;
    }
    if (currentFocusedLanguageIndex === 0) {
      return languagesCount - 1;
    }
    return --currentFocusedLanguageIndex;
  };

  return {
    focusNextLanguage,
    focusPreviousLanguage,
  };
};
